import api from './client';

export const shippingApi = {
  getSettings: () => api.get('/shipping/settings'),
  calculate: (data) => api.post('/shipping/calculate', data),
  getClasses: () => api.get('/shipping/classes'),
};
